import { render, staticRenderFns } from "./ElectrodeResistanceEdit.vue?vue&type=template&id=70f0965e&"
import script from "./ElectrodeResistanceEdit.vue?vue&type=script&lang=js&"
export * from "./ElectrodeResistanceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports